import { SuperAdminConstants } from '../../../_constants';

const initialState = { getFocusAreaTextLoading: true, data: '', error: false };

export function getFocusAreaTextReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_GET_FOCUS_AREA_TEXT:
            return {
                getFocusAreaTextLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_GET_FOCUS_AREA_TEXT:
            return {
                getFocusAreaTextLoading: false,
                data: action.getFocusAreaText,
                error: false
            };
        case SuperAdminConstants.GET_FOCUS_AREA_TEXT_ERROR:
            return {
                getFocusAreaTextLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/FocusAreaText/getFocusAreaText.reducer.js